import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems';
import MobileMenu from './MobileMenu';
import SearchPopup from './SearchPopup';
import Sidebar from './Sidebar';


const HeaderStyleThree = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isMobileMenu, setMobileMenu] = useState(false);
    const [isPopup, setIsPopup] = useState(false);
    const [isSidebar, setIsSidebar] = useState(false);

    const handleMobileMenu = () => {
        setMobileMenu(!isMobileMenu);
        if (!isMobileMenu) {
            document.body.classList.add("mobile-menu-visible");
        } else {
            document.body.classList.remove("mobile-menu-visible");
        }
    }

    const handlePopup = () => {
        setIsPopup(!isPopup);
    }

    const handleSidebar = () => {
        setIsSidebar(!isSidebar);
    }

    const handleScroll = () => {
            setIsVisible(window.scrollY > 100);
        };
    
        useEffect(() => {
            document.addEventListener("scroll", handleScroll);
            return () => document.removeEventListener("scroll", handleScroll);
        }, []);

    return (
        <React.Fragment>
            <style>
            {`
                .custom-header-wrapper {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    padding: 15px 0;
                }
                .custom-header-pill {
                    background: rgba(255, 255, 255, 0.08);
                    border: 1px solid rgba(255, 255, 255, 0.15);
                    backdrop-filter: blur(10px);
                    border-radius: 50px;
                    padding: 0 30px;
                    display: flex;
                    align-items: center;
                }
                .custom-header-pill .main-menu__list {
                    margin: 0;
                    display: flex;
                    align-items: center;
                }
                .custom-header-pill .main-menu__list > li {
                    padding: 15px 0;
                    margin-right: 24px;
                }
                .custom-header-pill .main-menu__list > li:last-child {
                    margin-right: 0;
                }
                .custom-header-pill .main-menu__list > li > a {
                    color: rgba(255,255,255,0.8) !important;
                    font-size: 14px;
                    font-weight: 500;
                    text-transform: capitalize;
                    transition: color 0.2s;
                }
                .custom-header-pill .main-menu__list > li:hover > a,
                .custom-header-pill .main-menu__list > li.current-menu-item > a {
                    color: var(--eventflow-base) !important;
                }
                .custom-header-right {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }
                .main-menu-three {
                    background: transparent !important;
                    position: absolute;
                    top: 0; left: 0;
                    width: 100%;
                    z-index: 99;
                }
                .stricky-header.stricky-fixed {
                    background: rgba(4,0,10,0.95) !important;
                    backdrop-filter: blur(16px);
                    border-bottom: 1px solid rgba(255,255,255,0.06);
                }
                /* hamburger button */
                .bsides-hamburger {
                    width: 40px; height: 40px;
                    border-radius: 8px;
                    background: rgba(255,255,255,0.06);
                    border: 1px solid rgba(255,255,255,0.12);
                    display: flex; flex-direction: column;
                    align-items: center; justify-content: center;
                    gap: 5px; cursor: pointer;
                    transition: all 0.25s;
                    padding: 0;
                }
                .bsides-hamburger:hover {
                    background: rgba(var(--eventflow-base-rgb),0.15);
                    border-color: rgba(var(--eventflow-base-rgb),0.3);
                }
                .bsides-hamburger__line {
                    width: 20px; height: 2px;
                    background: #fff; border-radius: 2px;
                    transition: all 0.25s;
                }
                .bsides-hamburger__line--mid { width: 14px; }
                .bsides-hamburger:hover .bsides-hamburger__line { background: var(--eventflow-base); }
                .bsides-hamburger:hover .bsides-hamburger__line--mid { width: 20px; }
                /* mobile logo size */
                @media (max-width: 576px) {
                    .main-menu__logo img { max-height: 80px !important; }
                    .custom-header-wrapper { padding: 10px 0; }
                }
            `}
            </style>
            <header className={`main-header main-header-three ${isVisible ? "fixed-header" : ""}`}>
                <nav className="main-menu main-menu-three">
                    <div className="container">
                        <div className="custom-header-wrapper">
                            {/* Logo */}
                            <div className="main-menu__logo">
                                <Link to="/">
                                    <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" style={{ maxHeight: '130px', filter: 'brightness(1.5) contrast(1.1)' }} />
                                </Link>
                            </div>

                            {/* Center Pill Menu */}
                            <div className="custom-header-pill d-none d-lg-flex">
                                <ul className="main-menu__list">
                                    <MenuItems
                                        parentMenu={parentMenu}
                                        secondParentMenu={secondParentMenu}
                                        activeMenu={activeMenu}
                                    />
                                </ul>
                            </div>

                            {/* Right Section */}
                            <div className="custom-header-right">
                                <Link to="/join" className="thm-btn d-none d-md-flex">
                                    Join Now <span className="icon-arrow-right"></span> 
                                </Link>
                                {/* Mobile Toggle */}
                                <div className="bsides-hamburger d-lg-none" onClick={handleMobileMenu}>
                                    <span className="bsides-hamburger__line" />
                                    <span className="bsides-hamburger__line bsides-hamburger__line--mid" />
                                    <span className="bsides-hamburger__line" />
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>

                <div className={`stricky-header stricked-menu main-menu ${isVisible ? "stricky-fixed" : ""}`}>
                    <div className="sticky-header__content" />
                    <nav className="main-menu main-menu-three">
                        <div className="container">
                            <div className="custom-header-wrapper">
                                <div className="main-menu__logo">
                                    <Link to="/">
                                        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" style={{ maxHeight: '130px', filter: 'brightness(1.5) contrast(1.1)' }} />
                                    </Link>
                                </div>
                                <div className="custom-header-pill d-none d-lg-flex">
                                    <ul className="main-menu__list">
                                        <MenuItems
                                            parentMenu={parentMenu}
                                            secondParentMenu={secondParentMenu}
                                            activeMenu={activeMenu}
                                        />
                                    </ul>
                                </div>
                                <div className="custom-header-right">
                                    <Link to="/join" className="thm-btn d-none d-md-flex">
                                        Join Now <span className="icon-arrow-right"></span> 
                                    </Link>
                                    <div className="bsides-hamburger d-lg-none" onClick={handleMobileMenu}>
                                        <span className="bsides-hamburger__line" />
                                        <span className="bsides-hamburger__line bsides-hamburger__line--mid" />
                                        <span className="bsides-hamburger__line" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            <MobileMenu handleMobileMenu={handleMobileMenu} />
            </header>
            <SearchPopup isPopup={isPopup} handlePopup={handlePopup} />
            <Sidebar isSidebar={isSidebar} handleSidebar={handleSidebar} />
        </React.Fragment>
    );
}

export default HeaderStyleThree;
